import { render, staticRenderFns } from "./AddSignatories.vue?vue&type=template&id=ef0a794e"
import script from "./AddSignatories.vue?vue&type=script&lang=js"
export * from "./AddSignatories.vue?vue&type=script&lang=js"
import style0 from "./AddSignatories.vue?vue&type=style&index=0&id=ef0a794e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports